var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSliders = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 2.5v11",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 2.5v11",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 2.5v11",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 6,
  r: 1.5,
  fill: "currentColor"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 10,
  r: 1.5,
  fill: "currentColor"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 5,
  r: 1.5,
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSliders);
export default ForwardRef;